import { useId, useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import './StayProcessSection.css';

gsap.registerPlugin(useGSAP, ScrollTrigger);

const steps = [
  { number: '01', title: 'Choose your place', description: 'Explore the destination and the home that fits your plans.' },
  { number: '02', title: 'Find your dates', description: 'Check availability and review the full stay details before you book.' },
  { number: '03', title: 'Make it yours', description: 'Complete your reservation and start looking forward to your stay.' },
];

export default function StayProcessSection({ ready = true }) {
  const scope = useRef(null);
  const titleId = useId();

  useGSAP(() => {
    if (!ready) return;
    const media = gsap.matchMedia();
    media.add('(prefers-reduced-motion: no-preference)', () => {
      const select = gsap.utils.selector(scope);
      const timeline = gsap.timeline({
        defaults: { duration: 0.7, ease: 'power3.out', clearProps: 'transform,opacity,visibility' },
        scrollTrigger: { trigger: scope.current, start: 'top 82%', once: true },
      });
      timeline
        .from(select('.stay-process__eyebrow'), { autoAlpha: 0, y: 10 }, 0)
        .from(select('.stay-process__heading'), { autoAlpha: 0, y: 25 }, 0.1)
        .from(select('.stay-process__step'), { autoAlpha: 0, y: 30, stagger: 0.12 }, 0.25)
        .from(select('.stay-process__badge'), { autoAlpha: 0, scale: 0.7, duration: 0.45, ease: 'back.out(1.5)', stagger: 0.12 }, 0.25)
        .from(select('.stay-process__copy'), { autoAlpha: 0, stagger: 0.12 }, 0.37);
    });
    return () => media.revert();
  }, { scope, dependencies: [ready], revertOnUpdate: true });

  return (
    <section ref={scope} className="stay-process" aria-labelledby={titleId}>
      <div className="stay-process__inner">
        <p className="stay-process__eyebrow">A SIMPLE WAY TO STAY</p>
        <h2 className="stay-process__heading" id={titleId}>From a little inspiration to your next escape.</h2>
        <div className="stay-process__grid">
          {steps.map(({ number, title, description }) => (
            <article className="stay-process__step" key={number}>
              <div className="stay-process__badge-hover">
                <span className="stay-process__badge">{number}</span>
              </div>
              <div className="stay-process__copy">
                <h3 className="stay-process__title">{title}</h3>
                <p className="stay-process__description">{description}</p>
              </div>
            </article>
          ))}
        </div>
        <div className="stay-process__divider" aria-hidden="true" />
      </div>
    </section>
  );
}
